<p class="text">
  This functionality is currently unavailable due to scheduled maintenance. Visit the
  <a [href]="legacyHomePage">home page</a> to view a banner with more details on the current maintenance period.
</p>
